// extracted by mini-css-extract-plugin
export default {"tag":"DashboardTag_tag__av0wl"};